<div class="wrapper w-100 {{formGroup.invalid && (formGroup.dirty || formGroup.touched) ? 'erro' : ''}}"
  [hidden]="!isVisible">
  @if (field?.type === 'Hidden') {
    <ui-hidden-field
      class="w-100"
      [config]="field"
      [item]="entity"
      [formGroup]="formGroup">
    </ui-hidden-field>
  }
  @if (field?.type === 'Date') {
    <ui-date-field
      class="w-100"
      [config]="field"
      [item]="entity"
      [formGroup]="formGroup">
    </ui-date-field>
  }
  @if (field?.type === 'Text') {
    <ui-text-field
      class="w-100"
      [config]="field"
      [item]="entity"
      [formGroup]="formGroup">
    </ui-text-field>
  }
  @if (field?.type === 'Checkbox') {
    <ui-checkbox-field
      class="w-100"
      [config]="field"
      [item]="entity"
      [formGroup]="formGroup">
    </ui-checkbox-field>
  }
  @if (field?.type === 'CpfCnpj') {
    <ui-cpf-cnpj-field
      class="w-100"
      [config]="field"
      [item]="entity"
      [formGroup]="formGroup">
    </ui-cpf-cnpj-field>
  }
  @if (field?.type === 'Enum') {
    <ui-enum-field
      class="w-100"
      [config]="field"
      [item]="entity"
      [formGroup]="formGroup">
    </ui-enum-field>
  }
  @if (field?.type === 'File') {
    <ui-file-field
      class="w-100"
      [config]="field"
      [item]="entity"
      [formGroup]="formGroup">
    </ui-file-field>
  }
  @if (field?.type === 'ImgFile') {
    <ui-img-file-field
      class="w-100"
      [config]="field"
      [item]="entity"
      [formGroup]="formGroup">
    </ui-img-file-field>
  }
  @if (field?.type === 'Autocomplete') {
    <ui-auto-complete-field
      class="w-100"
      [config]="field"
      [item]="entity"
      [formGroup]="formGroup">
    </ui-auto-complete-field>
  }
  @if (field?.type === 'Select') {
    <ui-select-field
      class="w-100"
      [config]="field"
      [item]="entity"
      [formGroup]="formGroup">
    </ui-select-field>
  }
  @if (field?.type === 'Radio') {
    <ui-radio-field
      class="w-100"
      [config]="field"
      [item]="entity"
      [formGroup]="formGroup">
    </ui-radio-field>
  }
  @if (formGroup.invalid && (formGroup.dirty || formGroup.touched) ) {
    <div class="error pt-0"
      >
      @for (error of errors; track error) {
        <small class="mat-error">{{validatorMessage(error)}}</small>
      }
    </div>
  }
</div>
